import { useState } from 'react';
import { Image } from '../../types/product';
import { elipsedText, getFileNameFromUrl } from '../../utils/commonUtils';

interface ImageViewerProps {
    images?: Array<Image>;
}

export default ({ images }: ImageViewerProps) => {
    const [activeImage, setActiveImage] = useState<Image | null>(null);
    const [activeImageIndex, setActiveImageIndex] = useState<number>(-1);

    const handleSetActiveImage = (image: Image | null, index: number) => {
        setActiveImage(image);
        setActiveImageIndex(index);
    };

    const handlePreviousClick = () => {
        let activeIndex = activeImageIndex;

        if (images && activeIndex > 0) {
            const nextImage = images[activeIndex - 1];
            setActiveImageIndex(activeIndex - 1);
            setActiveImage(nextImage);
        }
    };

    const handleNextClick = () => {
        let activeIndex = activeImageIndex;

        if (images && activeIndex < images.length - 1) {
            const nextImage = images[activeIndex + 1];
            setActiveImageIndex(activeIndex + 1);
            setActiveImage(nextImage);
        }
    };

    const getFormattedText = (text: string) => {
        const fileName = getFileNameFromUrl(text);
        return elipsedText(fileName, 20, 10, 10);
    };

    return (
        <>
            <div className="flex gap-4 flex-wrap">
                {images?.map((image: Image, index) => (
                    <img className="object-contain shadow-md w-20 h-20 cursor-pointer" src={image.url} onClick={() => handleSetActiveImage(image, index)} />
                ))}
            </div>
            {activeImage && (
                <div className="fixed z-40 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                    <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" onClick={() => handleSetActiveImage(null, -1)}></div>
                        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                            &#8203;
                        </span>
                        <div className="inline-block align-bottom bg-white rounded-lg text-left shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-7xl sm:w-full max-h-screen">
                            <div
                                className={`p-2 rounded-full shadow-md absolute -right-0 -top-4 bg-white flex items-center justify-center transition-all cursor-pointer ${
                                    activeImage ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
                                }`}
                                onClick={() => handleSetActiveImage(null, -1)}
                            >
                                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.3007 5.70997C17.9107 5.31997 17.2807 5.31997 16.8907 5.70997L12.0007 10.59L7.1107 5.69997C6.7207 5.30997 6.0907 5.30997 5.7007 5.69997C5.3107 6.08997 5.3107 6.71997 5.7007 7.10997L10.5907 12L5.7007 16.89C5.3107 17.28 5.3107 17.91 5.7007 18.3C6.0907 18.69 6.7207 18.69 7.1107 18.3L12.0007 13.41L16.8907 18.3C17.2807 18.69 17.9107 18.69 18.3007 18.3C18.6907 17.91 18.6907 17.28 18.3007 16.89L13.4107 12L18.3007 7.10997C18.6807 6.72997 18.6807 6.08997 18.3007 5.70997Z" />
                                </svg>
                            </div>
                            <div className="p-8">
                                <img src={activeImage.url} className="w-full object-contain mb-6" style={{ height: '65vh' }} alt="" />
                                <div className="flex justify-center items-center">
                                    <button className="bg-gray-100 w-10 h-10 rounded-full" onClick={handlePreviousClick}>
                                        <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M8.75949 13.907L3.35833 8.40958L8.75949 2.91219C9.30239 2.35962 9.30239 1.467 8.75949 0.91443C8.21659 0.361857 7.3396 0.361857 6.7967 0.91443L0.407175 7.41779C-0.135725 7.97036 -0.135725 8.86298 0.407175 9.41555L6.7967 15.9189C7.3396 16.4715 8.21659 16.4715 8.75949 15.9189C9.28847 15.3663 9.30239 14.4595 8.75949 13.907Z"
                                                fill="#717478"
                                            />
                                        </svg>
                                    </button>
                                    <div className="w-64 flex flex-col justify-center items-center">
                                        <div className="text-gray-500 whitespace-no-wrap text-base uppercase mb-1">images</div>
                                        <div className="text-gray-900 whitespace-no-wrap text-base">{getFormattedText(activeImage.url)}</div>
                                    </div>
                                    <button className="bg-gray-100 w-10 h-10 rounded-full" onClick={handleNextClick}>
                                        <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M1.24051 3.09303L6.64167 8.59042L1.24051 14.0878C0.697609 14.6404 0.697609 15.533 1.24051 16.0856C1.78341 16.6381 2.6604 16.6381 3.2033 16.0856L9.59282 9.58221C10.1357 9.02964 10.1357 8.13702 9.59282 7.58445L3.2033 1.0811C2.6604 0.528524 1.78341 0.528524 1.24051 1.0811C0.71153 1.63367 0.697609 2.54045 1.24051 3.09303Z"
                                                fill="#717478"
                                            />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
